import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ProductLogoMediumCertifications as LogoCertification } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_staff/certification/_list')({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation();

  const tabs = [
    {
      to: '/certification/overview',
      children: t('common.list.overview'),
      activeOptions: { exact: true },
    },
    {
      to: '/certification',
      children: t('common.list.certifications'),
      activeOptions: { exact: true },
    },
    {
      to: '/certification/people',
      children: t('common.list.people'),
    },
    {
      to: '/certification/alerts',
      children: t('common.list.alerts'),
    },
    {
      to: '/certification/operation-activity',
      children: t('common.list.operationActivity'),
    },
    {
      to: '/certification/rule-and-policy',
      children: t('common.list.ruleAndPolicy'),
    },
    {
      to: '/certification/settings',
      children: t('common.list.settings'),
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoCertification}
        name={t('pages.certification.list.pageTitle')}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
